<template>
  <div class="user_delete_archive">
  </div>
</template>

<script>

  export default {
    name: 'UserDeleteArchive',
    data() {
      return {
        user: [],
      }
    },
    created() {
      this.$http.delete(`user/archive/` + this.$route.params.id, {
        redirectOnFailure: {name: 'UserListArchive', params: {id: this.$route.params.id}},
        redirectOnSuccess: {name: 'UserListArchive', params: {id: this.$route.params.id}},
      })
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/User/delete_archive.vue